import React, { useState, useEffect } from 'react'
import { Button, Card, CardBody, CardFooter, FormGroup, Form, Input, Row, Col } from 'reactstrap'
import api from '../api'
import { setError, setSuccess } from '../redux/actions/alertActions'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

function UserProfile() {
  const dispatch = useDispatch()
  const [userData, setUserData] = useState({})
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [isDirty, setIsDirty] = useState(false) // Добавляем состояние для отслеживания изменений

  const {t} = useTranslation()

  useEffect(() => {
    // Получаем данные пользователя из localstorage
    const userFromLocalStorage = JSON.parse(localStorage.getItem('user'))
    if (userFromLocalStorage) {
      setUserData(userFromLocalStorage)
    }
  }, [])

  // Функция для обработки изменений в полях ввода
  const handleInputChange = event => {
    const { name, value } = event.target
    setUserData({ ...userData, [name]: value })
    setIsDirty(true) // Устанавливаем isDirty в true при изменении поля
  }

  // Функция для сохранения изменений
  const handleSave = () => {
    // Проверка, что пароль и подтверждение пароля совпадают
    if (password !== confirmPassword) {
      dispatch(setError(t('profile.passwordsError')))
      return
    }

    // Отправьте данные на бэкэнд в ожидаемом формате, включая пароль и подтверждение пароля
    const newUserInfo = {
      uid: userData.uid,
      login: userData.login,
      cid: userData.cid,
      name: userData.name,
      email: userData.email,
      grp: userData.grp,
      passwd: password, // Передаем пароль
      active: userData.active,
      strategies: userData.strategies,
    }

    api.userUpdate(newUserInfo).then(res => {
      newUserInfo.passwd = ''
      dispatch(setSuccess('Success'))
      localStorage.setItem('user', JSON.stringify(newUserInfo))
    })

    // После успешной отправки данных можно обновить компонент, если это необходимо
    setIsDirty(false) // Сбрасываем isDirty после успешного сохранения
  }

  return (
    <>
      <div className='content'>
        <Row>
          <Col md='6'>
            <Card>
              <CardBody>
                <h2>{t('profile.title')}</h2>
                <Form>
                  <Row>
                    {/*<Col className='pr-md-1' md='4'>*/}
                    {/*<FormGroup>*/}
                    {/*  <label>Company</label>*/}
                    {/*  <Input*/}
                    {/*    name='cid'*/}
                    {/*    value={userData.cid ? userData.cid.toString() : ''}*/}
                    {/*    placeholder='Company'*/}
                    {/*    type='text'*/}
                    {/*    onChange={handleInputChange}*/}
                    {/*    disabled={true}*/}
                    {/*  />*/}
                    {/*</FormGroup>*/}
                    {/*</Col>*/}
                    <Col className='pr-md-1' md='6'>
                      <FormGroup>
                        <label>{t('profile.login')}</label>
                        <Input
                          name='login'
                          value={userData.login}
                          placeholder={t('profile.login')}
                          type='text'
                          onChange={handleInputChange}
                          disabled={true}
                        />
                      </FormGroup>
                    </Col>
                    <Col className='pl-md-1' md='6'>
                      <FormGroup>
                        <label>{t('profile.group')}</label>
                        <Input
                          name='grp'
                          value={userData.grp}
                          placeholder={t('profile.group')}
                          type='text'
                          onChange={handleInputChange}
                          disabled={true}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className='pr-md-1' md='6'>
                      <FormGroup>
                        <label>{t('profile.name')}</label>
                        <Input
                          name='name'
                          value={userData.name}
                          placeholder={t('profile.name')}
                          type='text'
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col className='pl-md-1' md='6'>
                      <FormGroup>
                        <label htmlFor='exampleInputEmail1'>{t('profile.emailAddress')}</label>
                        <Input
                          name='email'
                          value={userData.email}
                          placeholder={t('profile.email')}
                          type='email'
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className='pr-md-1' md='6'>
                      <FormGroup>
                        <label>{t('profile.password')}</label>
                        <Input
                          name='password'
                          value={password}
                          placeholder={t('profile.password')}
                          type='password'
                          onChange={e => {
                            setPassword(e.target.value)
                            setIsDirty(true)
                          }}
                        />
                      </FormGroup>
                    </Col>
                    <Col className='pl-md-1' md='6'>
                      <FormGroup>
                        <label>{t('profile.confirmPassword')}</label>
                        <Input
                          name='confirmPassword'
                          value={confirmPassword}
                          placeholder={t('profile.confirmPassword')}
                          type='password'
                          onChange={e => {
                            setConfirmPassword(e.target.value)
                            setIsDirty(true)
                          }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
              <CardFooter>
                <Button
                  className='btn-fill'
                  color='primary'
                  onClick={handleSave}
                  disabled={!isDirty} // Делаем кнопку неактивной, если нет изменений
                >
                  {t('profile.save')}
                </Button>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default UserProfile
